/* [PATCH izdaja-carovnik v1] Čarovnik nastavitev izdaje: 4 koraki nad obstoječimi komponentami (IzdajaIzgled, IzdajaKartica).
   Zagon: samodejno v registru, ko podjetje še nima dokumentov in nastavitve.carovnik_opravljen ni true; ročno z ikono čarobne palice. */
import React, { useState } from 'react';
import { Check, ChevronLeft, ChevronRight, Wand2, X } from 'lucide-react';
import { api } from '../../lib/api';
import { IzdajaIzgled } from './IzdajaIzgled';
import { IzdajaKartica } from './IzdajaKartica';

const KORAKI = [
  { id: 'oblika', naslov: 'Oblika dokumenta', opis: 'Izberi predlogo — velja za vse nove račune, ponudbe in predračune. Predogled PDF pokaže vzorec.' },
  { id: 'slike', naslov: 'Logotip, žig, podpis', opis: 'Neobvezno. Logotip gre v glavo, žig in podpis desno spodaj. PNG s prozornim ozadjem je najlepši.' },
  { id: 'nastavitve', naslov: 'Nastavitve ročnega vnosa', opis: 'Rok plačila, kraj izdaje, IBAN, podpisnik, besedilo v nogi, e-pošta kupcu. Klikni Shrani, preden greš naprej.' },
  { id: 'stevilcenje', naslov: 'Številčenje', opis: 'Oblika številk za nove vrste in obstoječe številčne vrste. Klikni Shrani, preden končaš.' },
];
const btn = 'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-sm disabled:opacity-50';
const btnP = btn + ' bg-blue-600 text-white border-blue-600 hover:bg-blue-700';
const btnS = btn + ' bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-600 hover:border-blue-400';

export function IzdajaCarovnik({ companyId, stranka, onClose }: { companyId: string; stranka: boolean; onClose: (opravljen: boolean) => void }) {
  const [k, setK] = useState(0);
  const [koncujem, setKoncujem] = useState(false);
  const koncaj = async () => {
    setKoncujem(true);
    try { await api.put(`/izdaja/${companyId}/nastavitve`, { carovnik_opravljen: true }); } catch { /* neuspeh zapisa ne ustavi zapiranja */ }
    setKoncujem(false); onClose(true);
  };
  const korak = KORAKI[k];
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-start justify-center p-4 overflow-y-auto" onClick={() => onClose(false)}>
      <div className="w-full max-w-6xl my-4 bg-white dark:bg-gray-900 rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700" onClick={e => e.stopPropagation()}>
        <div className="flex items-center gap-3 px-5 py-4 border-b dark:border-gray-700">
          <Wand2 className="w-5 h-5 text-blue-600" />
          <div className="font-semibold">Čarovnik nastavitev izdaje</div>
          <div className="ml-auto flex items-center gap-1">
            {KORAKI.map((s, i) => (
              <button key={s.id} onClick={() => setK(i)} className={'flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs border transition ' + (i === k ? 'bg-blue-600 text-white border-blue-600' : i < k ? 'bg-emerald-50 text-emerald-700 border-emerald-300 dark:bg-emerald-500/10 dark:text-emerald-300' : 'text-gray-500 border-gray-300 dark:border-gray-600')}>
                <span className="font-mono">{i + 1}</span>{i < k && <Check className="w-3 h-3" />}<span className="hidden md:inline">{s.naslov}</span>
              </button>
            ))}
          </div>
          <button className="ml-2 p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800" title="Zapri (lahko nadaljuješ kasneje z ikono čarobne palice)" onClick={() => onClose(false)}><X className="w-4 h-4" /></button>
        </div>
        <div className="px-5 pt-4">
          <div className="text-lg font-semibold">{k + 1}. {korak.naslov}</div>
          <div className="text-sm text-gray-500 mt-0.5">{korak.opis}</div>
        </div>
        <div className="px-5 py-4">
          {korak.id === 'oblika' && <IzdajaIzgled companyId={companyId} stranka={stranka} del="predloga" />}
          {korak.id === 'slike' && <IzdajaIzgled companyId={companyId} stranka={stranka} del="slike" />}
          {korak.id === 'nastavitve' && <IzdajaKartica companyId={companyId} del="nastavitve" />}
          {korak.id === 'stevilcenje' && <IzdajaKartica companyId={companyId} del="stevilcenje" />}
        </div>
        <div className="flex items-center gap-2 px-5 py-3 border-t dark:border-gray-700">
          <button className={btnS} onClick={() => setK(x => Math.max(0, x - 1))} disabled={k === 0}><ChevronLeft className="w-4 h-4" /> Nazaj</button>
          <span className="text-xs text-gray-500">Vse nastavitve najdeš tudi pod Nastavitve → Prodaja.</span>
          <span className="ml-auto" />
          {k < KORAKI.length - 1
            ? <button className={btnP} onClick={() => setK(x => x + 1)}>Naprej <ChevronRight className="w-4 h-4" /></button>
            : <button className={btnP} onClick={koncaj} disabled={koncujem}><Check className="w-4 h-4" /> Končaj</button>}
        </div>
      </div>
    </div>
  );
}
